<template lang="pug">
.v-account-settings.account-settings
	v-loader(:loading="loading")
	.account-settings__danger(v-if="data")
		.account-settings__danger-head
			.account-settings__danger-title {{ data.removeTitle }}
			p.account-settings__danger-text(v-if="data.removeNote") {{ data.removeNote }}
		button.account-settings__danger-btn.btn.btn--warning.btn--round(
			type="button"
			@click="confirmRemove") {{ data.removeBtnText }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from "../scripts/controller/controller";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		removeAccount(action = null) {
			if (!action) return;
			this.dataLoad({
				url: this.data.remote,
				delay: true,
				data: {
					action
				}
			});
		},

		confirmRemove() {
			if (this.data.modalConfirmRemove) {
				controller.openModal({
					component: {
						...this.data.modalConfirmRemove,
						listeners: {
							'confirm': async () => {
								this.removeAccount('remove-account');
							},
						}
					}
				});
			} else {
				this.removeAccount('remove-account');
			}
		},
	},
}
</script>
